h6div
<template>
  <b-form class="w-100" @submit.prevent="validationForm">
    <b-row>
      <b-col>
        <ngo-search v-model="form.ngo_name" />
        <ngo-search
          label="الاسم البديل الأول"
          v-model="form.fst_alt_ngo_name"
        />
        <ngo-search
          label="الاسم البديل الثاني"
          v-model="form.sec_alt_ngo_name"
        />
      </b-col>
      <hr
        style="
          border: none;
          border-left: 1px solid #d8d6de;
          height: 350px;
          width: 1px;
        "
      />
      <b-col>
        <b-form-row>
          <b-col cols="6">
            <form-select
              label="الشكل القانوني"
              v-model="form.legal_form_type"
              :getOptionLabel="(x) => x.text"
              :reduce="(x) => x.value"
              id="legalForm"
              :options="legalFormOptions"
              ref="legalForm"
              rules="required"
            />
          </b-col>
          <b-col cols="6">
            <form-select
              label="يتناول نشاطها المحافظات"
              v-model="form.governorate_ids"
              :getOptionLabel="(x) => x.name_ar"
              :reduce="(x) => x.id"
              id="gov"
              ep="v2/guest/selects/governorates"
              ref="gov"
              rules="required"
              multiple
              :closeOnSelect="false"
            />
          </b-col>
          <b-col cols="6">
            <form-select
              label="محافظة المقر"
              :getOptionLabel="(x) => x.name_ar"
              :reduce="(x) => x.id"
              id="hqGov"
              ep="v2/guest/selects/governorates"
              ref="hqGov"
              rules="required"
              v-model="form.hqGovernorate"
            />
          </b-col>
          <b-col lg="6">
            <form-input
              rules="required"
              label="عنوان المقر"
              v-model="form.headquarters_address"
            />
          </b-col>
          <b-col lg="6">
            <form-input
              rules="required"
              label="رقم العقار"
              v-model="form.real_estate_number"
            />
          </b-col>
          <b-col cols="6">
            <form-select
              label="الشكل القانوني لإشغال مقر المنظمة"
              v-model="form.occupation_legal_form"
              :getOptionLabel="(x) => x.text"
              :reduce="(x) => x.value"
              id="occLegalForm"
              :options="propertyFormOptions"
              ref="occLegalForm"
              rules="required"
            />
          </b-col>
          <b-col cols="12">
            <class-select
              :legalForm="form.legal_form_type"
              v-model="form.classification_ids"
              rules="required"
            />
            <!-- <form-select
              label="التصنيفات"
              v-model="form.classification_ids"
              :getOptionLabel="(x) => x.name_ar"
              :reduce="(x) => x.id"
              id="class"
              ep="v2/guest/selects/classifications"
              ref="class"
              rules="required"
              multiple
              :closeOnSelect="false"
            /> -->
          </b-col>
          <b-col cols="12">
            <b-form-group
              description="الأهداف يجب أن لا تتجاوز الأربعة"
              label="الأهداف"
              label-for="legalForm"
            >
              <validation-provider
                mode="passive"
                #default="{ errors }"
                name="الأهداف"
                rules="required"
              >
                <b-form-textarea
                  v-model="form.objectives"
                  id="legalForm"
                  class="custom-control-success"
                  :state="errors.length > 0 ? false : null"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-form-row>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import FormSelect from "@/components/form-select";
import FormInput from "@/components/form-input";

import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BCard,
  BListGroup,
  BListGroupItem,
  BRow,
  BFormRow,
  BCol,
  BLink,
  BCardTitle,
  BCardText,
  BForm,
  BButton,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BFormRadioGroup,
  BFormCheckbox,
  BFormTextarea,
} from "bootstrap-vue";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import debounce from "lodash.debounce";
import NgoSearch from "@/components/NgoSearch.vue";
import ClassSelect from "@/components/class-select";
export default {
  components: {
    VuexyLogo,
    // BSV
    BCard,
    BListGroup,
    BListGroupItem,
    BRow,
    BFormRow,
    BCol,
    BLink,
    BCardTitle,
    BCardText,
    BForm,
    BButton,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BFormRadioGroup,
    BFormCheckbox,
    BFormTextarea,
    FormInput,
    FormSelect,
    // validations
    ValidationProvider,
    ValidationObserver,
    NgoSearch,
    ClassSelect,
  },
  mixins: [togglePasswordVisibility],
  props: {
    value: Object,
  },
  data() {
    return {
      legalFormOptions: [
        {
          text: "جمعية",
          value: "association",
        },
        {
          text: "مؤسسة",
          value: "institution",
        },
        {
          text: "اتحاد",
          value: "alliance",
        },
      ],
      propertyFormOptions: [
        {
          text: "عقد إيجار",
          value: "lease",
        },
        {
          text: "حق انتفاع",
          value: "usufruct",
        },
        {
          text: "عقد عارية",
          value: "loan",
        },
        {
          text: "تخصيص إداري",
          value: "administrative_allocation",
        },
      ],

      confirmFieldType: "password",
      // validation rules
      required,
      email,
      confirmed,
      url,
      between,
      alpha,
      integer,
      password,
      min,
      digits,
      alphaDash,
      length,
    };
  },
  watch: {
    "form.ngo_name": debounce(function (value) {
      this.$store.dispatch(`NgoHome/main/getOrganizations`, {
        currentPage: 1,
        filter: value,
      });
    }, 500),
  },
  computed: {
    getOrg() {
      return this.$store.getters["NgoHome/main/ngoOrganizations"];
    },
    form: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  methods: {
    validationForm() {
      this.$refs.registerForm.validate().then((success) => {
        if (success) {
          this.$emit("validationSuccess");
          resolve(true);
        } else {
          reject(false);
        }
      });
    },
  },
};
</script>

<style lang="scss">
.custom-radio {
  span {
    font-size: smaller;
  }
}
.ngo-cont {
  height: 220px;
  margin-bottom: 10px;
  overflow: auto;
  scroll-padding: 20px;
  scrollbar-width: thin;
}
</style>
